import { yup } from '../../../shared/utils/yup';
import { IPortalQuestion } from '../../question/types';

const yupQuestion: Partial<Record<keyof IPortalQuestion, yup.BaseSchema>> = {};

export const questionSchema = yup.object({}).shape(yupQuestion);
